﻿import * as React from "react";

export interface IDataFeedStatusTitle {
    word: string;
    color: string;
}

export interface IDataFeedStatusTitleProps {
    keyElements: IDataFeedStatusTitle[];
}

export const DataFeedStatusTitle: React.FunctionComponent<
    IDataFeedStatusTitleProps
> = (props: IDataFeedStatusTitleProps): React.ReactElement => (
    <div className={`datafeedstatusTableTitle`}>
        Key:
        {props.keyElements.map((element: IDataFeedStatusTitle) => (
            <span key={element.word}>
                <div
                    className={`box`}
                    style={{ backgroundColor: element.color }}
                />
                {element.word}
            </span>
        ))}
    </div>
);
